import React, { useContext, useMemo, useState } from 'react';
import { GiveawayContext } from '@/state/state';
import { TechnicalInformationAccordion } from '@/components/technicalInformation/technicalInformationAccordion';
import { ChevronDown, ChevronUp } from '@volkswagen-onehub/icons-core';
import { t } from 'i18next';
import styled from 'styled-components';
import { CTA } from '@volkswagen-onehub/components-core';
import { hasRenderableValue } from '@/util/technicalData.helper';

const StyledButton = styled(CTA)`
  margin: 40px auto 0;
  display: flex;
`;

export const TechnicalInformation = (): React.JSX.Element | null => {
  const [showAll, setShowAll] = useState(false);
  const { technicalData } = useContext(GiveawayContext);

  if (!technicalData?.length) {
    return null;
  }

  const sorted = useMemo(() => {
    return technicalData
      .map((category) => ({
        ...category,
        values: (category.values ?? []).filter(({ value }) => hasRenderableValue(value)),
      }))
      .filter((category) => category.values.length > 0)
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [technicalData]);

  const visibleAccordions = showAll ? sorted : sorted.slice(0, 5);
  const hasMore = sorted.length > 5;

  const showMoreText = t('equipmentAccordion.showMoreButton');
  const showLessText = t('equipmentAccordion.showLessButton');
  return (
    <div>
      {visibleAccordions.map(({ name, values }) => (
        <TechnicalInformationAccordion
          key={name}
          name={name}
          values={values}
          collapseAll={!showAll}
        />
      ))}

      {hasMore && (
        <StyledButton
          icon={
            showAll ? (
              <ChevronUp variant="small" aria-hidden />
            ) : (
              <ChevronDown variant="small" aria-hidden />
            )
          }
          tag="button"
          emphasis="secondary"
          onClick={() => setShowAll((prev) => !prev)}
        >
          {showAll ? showLessText : showMoreText}
        </StyledButton>
      )}
    </div>
  );
};
